<ion-content>

    <custom-header [class]="themeConfig.name"></custom-header>

    <ion-row *ngIf="!credential"
             class="loading">
        <ion-col>
            <ion-spinner></ion-spinner>
        </ion-col>
    </ion-row>

    <ion-row *ngIf="credential"
             class="credential">
        <ion-col size="12"
                 size-lg="6"
                 class="image">
            <div>
                <ion-slides *ngIf="credential.certification_preview"
                            #slider
                            [pager]="true"
                            [options]="slideOpts">
                    <ion-slide>
                        <img [src]="plt.createSignedLink(credential.certification_preview, true)"
                             draggable="false"
                             [alt]="credential.certification_name" />
                    </ion-slide>
                    <ion-slide *ngIf="credential.certification_badge">
                        <img [src]="plt.createSignedLink(credential.certification_badge, true)"
                             [ngClass]="{'badge': !!credential.certification_preview}"
                             draggable="false"
                             [alt]="credential.certification_name" />
                    </ion-slide>
                </ion-slides>
            </div>
            <img *ngIf="!credential.certification_preview"
                 [src]="plt.createSignedLink(credential.certification_badge, true)"
                 [ngClass]="{'badge': !!credential.certification_preview}"
                 draggable="false"
                 [alt]="credential.certification_name" />
        </ion-col>
        <ion-col class="detail"
                 size="12"
                 size-lg="6">
            <h1>{{credential.certification_name}}</h1>
            <h2>{{credential.recipient}}</h2>
            <ion-row>
                <ion-col size="12"
                         size-md="6"
                         class="number">
                    <div>
                        {{'CREDENTIAL_PAGE_NUMBER' | trns}}<br /> <strong>{{credential.certification_number}}</strong><br />
                        {{'CREDENTIAL_PAGE_ISSUER' | trns}}<br /> <strong>
                            <ng-container *ngIf="!credential.certification_issuer_url">
                                {{credential.certification_issuer}}
                            </ng-container>
                            <a *ngIf="credential.certification_issuer_url"
                               [href]="credential.certification_issuer_url">
                                {{credential.certification_issuer}}
                            </a>
                        </strong>
                    </div>
                </ion-col>
                <ion-col size="12"
                         size-md="6"
                         class="verify">
                    <div class="item">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/bitcoin.svg">
                        </svg-icon>
                        {{'CREDENTIAL_WALLET_BLOCKCHAIN_ID'| translate}}
                        <strong *ngIf="credential.blockchain_id">{{credential.blockchain_id}}</strong>
                        <strong *ngIf="!credential.blockchain_id"
                                class="help"
                                [title]="'CREDENTIAL_WALLET_BLOCKCHAIN_ID_PENDING_HELP' | trns">
                            <span title="">{{'CREDENTIAL_WALLET_BLOCKCHAIN_ID_PENDING'| translate}}</span>
                        </strong>
                    </div>
                    <div class="item approval">
                        <svg-icon [applyClass]="true"
                                  src="/assets/icons/approval.svg">
                        </svg-icon>
                        <span [innerHTML]="'CREDENTIAL_WALLET_ISSUER_VERIFIED'| translate"></span>
                    </div>
                </ion-col>
            </ion-row>

            <hr />

            <div *ngIf="credential.description"
                 class="description"
                 [innerHTML]="credential.description | safe:'html'">
            </div>
            <ng-container *ngIf="credential.course_link">
                <br />
                <a [href]="credential.course_link"
                   target="_blank">{{'CREDENTIAL_PAGE_COURSE_LINK' | trns}}
                </a>
                <br /><br />
            </ng-container>


            <ion-row>
                <ion-col size="6">
                    {{'CREDENTIAL_ISSUED_ON' | trns}}<br />
                    <strong>{{credential.certification_issued_on | datex}}</strong>
                </ion-col>
                <ion-col size="6">
                    {{'CREDENTIAL_EXPIRES_ON' | trns}}<br />
                    <ng-container *ngIf="credential.certification_expires_on">
                        <strong>{{credential.certification_expires_on | datex}}</strong>
                    </ng-container>
                    <ng-container *ngIf="!credential.certification_expires_on">
                        {{'CREDENTIAL_EXPIRES_ON_NOT' | trns}}
                    </ng-container>
                </ion-col>
            </ion-row>
            <div class="register">
                <p>
                    {{'CREDENTIAL_REGISTER_HINT' | trns}}
                </p>
                <a class="btn btn-primary"
                   href="https://skillsclub.com/registration/"
                   target="_blank">
                    {{ 'LOGIN_REGISTER_LINK_TEXT' | translate }}
                </a>
            </div>
        </ion-col>
    </ion-row>

    <custom-footer></custom-footer>
</ion-content>